import { OnboardNewStudentRequest, OnboardNewTeacherRequest, RegisterExistingStudentRequest, RegisterExistingTeacherRequest, RegistrationCheckRequest, RegistrationDistrictTokenResponse } from "@carnegie-learning/data-access-angular-passport";
import { createAction, props } from "@ngrx/store";
import { PPUser as User } from "cli-types";

/** Registration Check */
export const registerRegistrationCheckAttempt = createAction(
    "[Register] Registration Check Attempt",
    props<{
        payload: RegistrationCheckRequest;
        email: string;
        inviteHash: string;
    }>()
);
export const registerRegistrationCheckSuccess = createAction(
    "[Register] Registration Check Success",
    props<{
        email: string;
        inviteHash: string;
    }>()
);
export const registerRegistrationCheckFail = createAction(
    "[Register] Registration Check Fail",
    props<{ payload: any }>()
);

/** Register Steps */
export const registerCancel = createAction("[Register] Cancel");
export const registerStep1 = createAction("[Register] Step 1");
export const registerStep2 = createAction("[Register] Step 2");

/** Registration Form */
export const registerFormAttemptStudent = createAction(
    "[Register] Form Attempt Student",
    props<{ payload: OnboardNewStudentRequest }>()
);
export const registerFormAttemptTeacher = createAction(
    "[Register] Form Attempt Teacher",
    props<{ payload: OnboardNewTeacherRequest }>()
);
export const registerFormSuccess = createAction(
    "[Register] Form Success",
    props<{ payload: User }>()
);
export const registerFormFail = createAction(
    "[Register] Form Fail",
    props<{ payload: any }>()
);

/** Register Other */
export const registerAutoLogin = createAction("[Register] Auto Login");
export const registerAuthFail = createAction("[Register] Auth Fail");
export const registerResetState = createAction("[Register] Reset State");
export const registerMaintenance = createAction("[Register] Maintenance");

/** Registration Form */
export const registerFormAttemptExistingTeacher = createAction(
    "[Register] Form Attempt Existing Teacher",
    props<{ payload: RegisterExistingTeacherRequest }>()
);
export const registerFormAttemptExistingStudent = createAction(
    "[Register] Form Attempt Existing Student",
    props<{ payload: RegisterExistingStudentRequest }>()
);
export const registerFormSuccessExistingUser = createAction(
    "[Register] Form Success Existing User",
    props<{ payload: RegisterExistingTeacherRequest | RegisterExistingStudentRequest }>()
);

/** Registration Form - FIDO login follow up

/** Register via district URL */
export const registerDistrictNoToken = createAction(
    "[Register] No District Invite Token Found"
);
export const registerDistrictTokenCheckAttempt = createAction(
    "[Register] District Token Check Attempt",
    props<{ inviteHash: string }>()
);
export const registerDistrictTokenCheckSuccess = createAction(
    "[Register] District Token Check Success",
    props<{ payload: RegistrationDistrictTokenResponse }>()
);
export const registerDistrictTokenCheckFail = createAction(
    "[Register] District Token Check Fail",
    props<{ message: string }>()
);
